import { useParams  } from 'react-router-dom';
import Login from '../auth/Login';
import Register from '../auth/Register';

function Authent({setCurrentUser}) {

    const mode = useParams().type;

    // Login or Register
    return (
        (mode === 'login') ? (
            <div className='login'>
                <h1>Vous avez déjà un compte ? </h1>
                <Login setCurrentUser={setCurrentUser} />
            </div>
        ) : (
            <div className='register'>
                {/*<h1>Pas de compte ? </h1>
                <Register setCurrentUser={setCurrentUser} />*/}
            </div>
        )
    );
}

export default Authent;